export const CREATE_CUSTOMER = '/api/customers/create';
export const CREATE_SUBSCRIPTION = '/api/subscriptions/create';
export const CREATE_SETUP_INTENT = '/api/setup-intents/create';

export const CREATE_GIFT_CHECKOUT_SESSION = '/api/gifts/create-checkout-session';
export const LOOKUP_GIFT = '/api/gifts/lookup';
export const LOOKUP_GIFT_ORDER = '/api/gifts/order';
export const REDEEM_GIFT = '/api/gifts/redeem';